import { defineMessages } from 'react-intl';

export default defineMessages({
	breadcrumbsLabel: {
		id: 'cv.portal.breadcrumbs.container',
		defaultMessage: 'Breadcrumbs',
		description:
			'The accessible label for the breadcrumb navigation container shown at the top of the portal page.',
	},
	raiseRequestBreadcrumb: {
		defaultMessage: 'Raise a request',
		description: 'Breadcrumb item to go to select a request group of a portal',
		id: 'cv.portal.breadcrumbs.raise.request',
	},
	breadcrumbsHome: {
		defaultMessage: 'Home',
		description: 'Generic label for the first entry of the breadcrumbs for Service hub',
		id: 'cv.portal.breadcrumbs.home',
	},
});
